import { Badge } from "@/components/ui/badge";
export function StatusBadge({ value, testId }) { return <Badge className={`status-badge status-${String(value).toLowerCase().replaceAll(" ", "-")}`} data-testid={testId}>{value}</Badge>; }
